
import React, { Component } from 'react';
import * as ReactDOM from 'react-dom';
import axios from 'axios';
import Signup from './Signup';
import Configdata from './Defaultdata';

import {isvalidatemail,isvalidmob,isvaluenull,isequal,isnumber} from './validation';
import { getmessage,wrongmsg,getusertype,searchpostnow,clearform,displayprofile } from './Dynamictable';
import { cityidfromcod } from './userdefaultdata';
import Usersession from './Usersession';
class Forgotpassword extends Component {
	constructor(props: any) {
   	super(props);
	this.state.togglesineup = false;
    	this.state.ltypeguest = false;

  	}
	state = {
        name: "",
	email:"",
	phone:"",
	points:"",
	paswrd:"",
	reentry:"",
	code:"",
        togglecrit: false,
        togglesineup:false,
	slcttype:false,
	ltypeguest:false,
	
    	};

	
	typeselect(e: any){
		
		this.desecttypes();
		const eid = e.target.id;
		e.target.style.backgroundColor = 'green';

		//alert(eid);
		

		e.preventDefault()

	};
	usersineup(e: any){
	   try {
		
		const signups = <Signup />
             
                var maindiv = document.getElementById('container') as HTMLElement;
		const Pdivr = document.getElementById('profilediv') as HTMLElement;
		if(maindiv){
		ReactDOM.render(signups,maindiv);
		maindiv.style.display = 'block';
	        }
		if(Pdivr){
		Pdivr.style.display = 'none';
		}
		//alert(maindiv.style.display);
	   }
	    catch(e){
		
	     }	
	     e.preventDefault()

	};
	recovryvalidate(){
	 let isvalid = true;
		
		if(!isvalidatemail(this.state.email)){
		 getmessage('Please enter a valid mail Id','');
	  	return false;
		}
		if(!isvalidmob(this.state.phone)){
		 getmessage('Please enter a valid 10 digit mobil no','');
	  	return false;
		}
			
	return isvalid;
	}
	setpasswordalidate(){
	 let isvalid = true;
		
		if(isvaluenull(this.state.points)){
		 getmessage('Point should not blank','');
	  	return false;
		}
		if(!isnumber(this.state.points)){
		 getmessage('Point should be number','');
	  	return false;
		}
	        if(isvaluenull(this.state.paswrd)){
		 getmessage('Password should not blank','');
	  	return false;
		}
		if(!isequal(this.state.paswrd,this.state.reentry)){
		 getmessage('Re enter password not matched','');
	  	return false;
		}
		if(!(this.state.code.length > 0)){
		 getmessage('Please try again','');
	  	return false;
		}	
	return isvalid;
	}
	

	desecttypes(){
		this.setState({ slcttype: false });
		

		
	}
	displayenrtryname(d: any){
	const unamedv = document.getElementById('unamediv') as HTMLElement;

	 if(d == 0) unamedv.style.display = 'none';
	 else 	unamedv.style.display = 'block';

	}
	displayenrtryemail(d: any){
	const umail = document.getElementById('uemailodiv') as HTMLElement;

	 if(d == 0) umail.style.display = 'none';
	 else 	umail.style.display = 'block';

	}
	displayenrtrypass(d: any){
	const upass = document.getElementById('upassdiv') as HTMLElement;

	 if(d == 0) upass.style.display = 'none';
	 else 	upass.style.display = 'block';

	}


	componentDidMount() {
        //debugger;
     	 //this.guestlogindivshow();

     	//this.closeivbyId('pswdrecovery',false);
	// this.closeivbyId('userauthodiv',true);
    	}
	showrecoverydiv(){
	 this.closeivbyId('userauthodiv',false);
	 this.closeivbyId('pswdrecovery',true);
	
	}
	rcvrychangepswd(event: any) {
	
         const id = event.target.id;
	const elvalue = event.target.value;
	//alert(id);
        if(id == 'txtrcpmailid'){
        
	 this.setState({ email: elvalue });
	}
	else if(id == 'txtrcpphone'){
	
	 this.setState({ phone: elvalue });
	}
	else if(id == 'txtrcppoints'){
	
	 this.setState({ points: elvalue });
	}
	else if(id == 'txtrcpnewpswd'){
	
	 this.setState({ paswrd: elvalue });
	}
	else if(id == 'txtrcpreentrypswd'){
	
	 this.setState({ reentry: elvalue });
	}
	
   }
getusercode(e: any){
 try {
		if(this.recovryvalidate()){
          	getmessage('On Process Please wait.....','');	
		
		const usermail = this.state.email;
		const mobile = this.state.phone;
                const response = axios.post(Configdata.srvurl + '/recoverycodebymail', {
    		
    		phone: mobile,
		uemail: usermail
              
  		}, {
    		    headers: {
      				'Content-Type': 'application/json'
    			      }
  			}
		);
	      
                if(response){
		 response.then((result:any) => {
		const usercd = result.data;
		
		if(usercd == 'NA'){
		getmessage('Please try again','');
		}
		else{
		this.setState({ code: usercd });
		getmessage(usercd,'');
		this.showrecoverydiv();
		}
		
		
	        });		
              }
		
	   }
          }
        catch (e) {
           // debugger;
		wrongmsg();
        }


e.preventDefault()
}
setuserlogin(e:any){

 
  		
  e.preventDefault()
}

setuserpassword(e: any){
	 try {
		if(this.setpasswordalidate()){
          		
		getmessage('On Process Please wait.....','');

                const response = axios.post(Configdata.srvurl + '/setpswdbypoints', {
    		
    		points: this.state.points,
		pswd: this.state.paswrd,
                code: this.state.code
		
  		}, {
    		    headers: {
      				'Content-Type': 'application/json'
    			      }
  			}
		);
	      
                if(response){
		 response.then((result:any) => {
		const usercd = result.data;
		
		if(usercd == 'NA'){
		getmessage('Please try again','');
		}
		else{
		this.setState({ code: usercd });
		//getmessage(usercd,'');
		//this.showrecoverydiv();
		const vld = clearform('frmforgotpswd');
		displayprofile();
		}
		
		
	        });		
              }
		
	   }
          }
        catch (e) {
           // debugger;
		wrongmsg();
        }


e.preventDefault()

}
     closeprofilediv(){
	const Pdivr = document.getElementById('profilediv') as HTMLElement;
	Pdivr.style.display ='none';
     }
     closeivbyId(divid:any,opt:any){
	const Pdivr = document.getElementById(divid) as HTMLElement;
	if(Pdivr){
	if(opt)
	Pdivr.style.display ='block';
	else
	Pdivr.style.display ='none';
	}

      }	
	render() {
		return (
		<form id="frmforgotpswd">
			
                <div id="sinupsidebardiv" className="sidebar-search" style={{width:'80vw'}}>

		     <div className="search-title-bar">
                       	<div className="search-title">
			Recovery Password			  
			</div>
			
	   	     </div>
		  <div id="userauthodiv" className="sidebar-scroll">
		   	
		     
		   <div className="sidebar-basic-info" id="upassworddiv" style={{width:'90%',marginTop:'5vh'}}>
		       <div>	
			 <div className="searchtype" id="loginpswrd" style={{width:'94%'}}>
		 <input placeholder="Enter Your mail Id"  onChange={e => this.rcvrychangepswd(e)} id="txtrcpmailid" type="text" style={{width:'90%'}}/>
	
			 </div>
 
		       </div>
		    </div>

		   <div className="sidebar-basic-info" id="unewpswddiv" style={{width:'90%',marginTop:'5vh'}}>
		       <div>	
			 <div className="searchtype" id="loginuseremail" style={{width:'94%'}}>
			 <input placeholder="Enter Phone No"  onChange={e => this.rcvrychangepswd(e)} id="txtrcpphone" type="text" style={{width:'90%'}}/>
	
			 </div>
 
		       </div>
		    </div>
		     
	
		   
		   	
		     <div className="sidebar-basic-info" style={{width:'100%' ,marginTop:'5vh',height:'60px'}}>
		       <div> 
			

                       	<div id="signupdiv" style={{width:'55%',float:'left',padding:'10px'}}>
			

			</div>
			
			<a href="#" onClick={e => this.getusercode(e)} title="Sale">

			<div className="searchtype" onClick={e => this.getusercode(e)}  id="submitrcppassword" style={{width:'28%',float:'left'}}>
			  Submit	
			</div>
			</a>
		     </div>
		    </div>

 		   


		 </div>


	       <div id="pswdrecovery" className="sidebar-scroll" style={{display:'none'}}>
		   	
		     
		   <div className="sidebar-basic-info" id="upassworddiv" style={{width:'90%',marginTop:'5vh'}}>
		       <div>	
			 <div className="searchtype" id="rcppoinbts" style={{width:'94%'}}>
	 <input placeholder="Enter total points"  onChange={e => this.rcvrychangepswd(e)} id="txtrcppoints" type="text" style={{width:'90%'}}/>
	
			 </div>
 
		       </div>
		    </div>

		   <div className="sidebar-basic-info" id="unewpswddiv" style={{width:'90%',marginTop:'5vh'}}>
		       <div>	
			 <div className="searchtype" id="loginuseremail" style={{width:'94%'}}>
			 <input placeholder="Enter password"  onChange={e => this.rcvrychangepswd(e)} id="txtrcpnewpswd" type="text" style={{width:'90%'}}/>
	
			 </div>
 
		       </div>
		    </div>
		 <div className="sidebar-basic-info" id="rcpnewpswddiv" style={{width:'90%',marginTop:'5vh'}}>
		       <div>	
			 <div className="searchtype" id="rcpreentrypswddv" style={{width:'94%'}}>
	 <input placeholder="Re enter password"  onChange={e => this.rcvrychangepswd(e)} id="txtrcpreentrypswd" type="text" style={{width:'90%'}}/>
	
			 </div>
 
		       </div>
		    </div>
			     
	
		   
		   	
		     <div className="sidebar-basic-info" style={{width:'100%' ,marginTop:'5vh',height:'60px'}}>
		       <div> 
			

                       	<div id="signupdiv" style={{width:'55%',float:'left',padding:'10px'}}>
			
			

			</div>
			
			<a href="#" onClick={e => this.setuserpassword(e)} title="Sale">

			<div className="searchtype" id="submitrecovery" style={{width:'28%',float:'left'}}>
			  Submit	
			</div>
			</a>
		     </div>
		    </div>

 		   


		 </div>
	
	      </div>

		

		</form>
		);
	}

	
}

export default Forgotpassword;
